var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.65757 9.25316C4.30906 6.47574 6.4777 4.30711 9.25512 3.65561C11.2609 3.18511 13.3484 3.18511 15.3543 3.65561C18.1317 4.30711 20.3003 6.47574 20.9518 9.25317C21.4223 11.259 21.4223 13.3465 20.9518 15.3523C20.3003 18.1297 18.1317 20.2984 15.3543 20.9499C13.3484 21.4204 11.2609 21.4204 9.25512 20.9499C6.4777 20.2984 4.30906 18.1297 3.65757 15.3523C3.18706 13.3465 3.18706 11.259 3.65757 9.25316Z",
    fill: "white",
    fillOpacity: 0.15,
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8047 12.3027H9.80469M12.3047 14.8027L12.3047 9.80273",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.3695963858ce758050ed9c1007dd4ad8.svg";
export { ForwardRef as ReactComponent };